import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { BuildInfoService } from '../../../services/build-info.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BuildInfo } from '../../../domain/build-info.model';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DefaultYearService } from '../../../services/default-year.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [DatePipe, FormsModule],
})
export class FooterComponent implements OnInit {
  private buildInfoService = inject(BuildInfoService);
  protected readonly defaultYearService = inject(DefaultYearService);

  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  buildInfo!: BuildInfo;
  currentYear: number = new Date().getFullYear();

  ngOnInit(): void {
    this.buildInfoService
      .getBuildInfo()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: buildInfo => {
          this.buildInfo = buildInfo;
        },
      });
  }
}
